/** Human-readable booking status labels (KAN-66). */
export function formatBookingStatus(booking) {
  const status = typeof booking === "string" ? booking : booking?.status;
  const reason = typeof booking === "object" ? booking?.expired_reason : null;
  if (status === "expired") {
    if (reason === "no_show" || !reason) return "Expired / No-show";
    return "Expired";
  }
  if (status === "pending_partner_confirmation") return "Pending partner";
  if (!status) return "—";
  return status.charAt(0).toUpperCase() + status.slice(1);
}

export function bookingStatusDotClass(status) {
  if (status === "completed") return "live";
  if (status === "cancelled" || status === "expired") return "error";
  return "pending";
}
